export function initVisualSelect() {
  document.querySelectorAll(".js-visual-select").forEach((visualSelect) => {
    const select = visualSelect.previousElementSibling;

    const options = visualSelect.querySelectorAll("button");
    if (options && options.length > 0) {
      options.forEach((fakeOption) => {
        fakeOption.addEventListener("click", (e) => {
          e.preventDefault();

          if (!select) return;

          const variant = fakeOption.dataset.variant;
          if (variant === undefined) return;
          if (fakeOption.getAttribute("disabled") !== null) return;
          select.querySelectorAll("option").forEach((option, ix) => {
            if (ix === parseInt(variant)) {
              option.selected = true;
              select.dispatchEvent(new Event("change"));
            }
          });
          select.classList.add("loading");
        });
      });
    }
  });
}
